// Route words that share the /login/:portal path shape (or can otherwise leak
// into portal state) but are NOT real portal slugs. Persisting one as the
// active portal poisons the X-Portal header: a hardcoded /login/user redirect
// once shipped X-Portal: user, which 404'd membership plans and made the API
// reject the portal with a 422 "The selected portal is invalid".
export const RESERVED_NON_PORTAL_SLUGS = ['user'];

// True when a would-be portal slug is actually a reserved route word that must
// never be written to selectedPortal / sent as X-Portal.
export function isReservedPortalSlug(slug: string | null | undefined): boolean {
   if (!slug) {
      return false;
   }
   return RESERVED_NON_PORTAL_SLUGS.includes(slug.trim().toLowerCase());
}
